<template>
  <div class="fragrance-finder container">
    <div class="row">
      <div class="col-sm-3 col-xs-6">
        <span class="result-count">
          {{ resultsCountText }}
          <span class="hidden-xs">
            found
          </span>
        </span>
      </div>

      <div class="col-sm-offset-6 col-sm-3 col-xs-6">
        <label class="sort-label" for="fragrance-finder-ranking">
          Sort<span class="hidden-xs">:</span>
        </label>
        <select
          name="fragrance-finder-ranking"
          class="sort-select-box"
          @change="changeSearchIndex"
        >
          <option
            v-for="(searchIndex, index) in searchIndices"
            :key="index"
            :value="searchIndex"
          >
            {{ searchIndex }}
          </option>
        </select>

        <div class="pull-right">
          <span class="hidden-md-up">
            <a class="sliding-menu-toggle" @click="toggleMobileFacetMenu()">
              Filter
            </a>
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-3">
        <div :class="slidingMenuCssClasses">
          <div class="mobile-facets">
            <facet-sidebar
              :facet-groups="facetGroups"
              :selected-filters="selectedFilters"
              @toggle-filter="toggleFilter"
            />
          </div>

          <div class="mobile-menu-options hidden-md-up">
            <div class="row">
              <div class="col-xs-6">
                <button class="btn on-menu-button reset-button" @click="clearAll">
                  Reset
                </button>
              </div>
              <div class="col-xs-6">
                <button
                  class="btn btn-primary on-menu-button done-button"
                  @click="toggleMobileFacetMenu()"
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-9 col-xs-12">
        <filter-row
          :selected-filters="selectedFilters"
          @clear-all="clearAll"
          @toggle-filter="toggleFilter"
        />

        <template v-if="anyResults">
          <div class="product-grid">
            <div class="row">
              <fragrance-search-result
                v-for="(fragrance, index) in fragrances"
                :key="index"
                :fragrance="fragrance"
              />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable no-undef */

  import AlgoliaClient from 'lib/storefront/algolia-client';
  import searchOptions from 'lib/storefront/fragrance-finder/algolia-config';
  import FacetParser from 'lib/storefront/fragrance-finder/facet-parser';
  import FacetSidebar from './fragrance-finder/facet-sidebar.vue';
  import FilterRow from './fragrance-finder/filter-row';
  import Fragrance from './fragrance-finder/fragrance.vue';

  export default {
    components: {
      FacetSidebar,
      FilterRow,
      'fragrance-search-result': Fragrance
    },
    props: {
      searchIndexNames: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        mobileFacetMenuOpen: false,
        screenLockClass: 'frozen',
        searchClient: new AlgoliaClient({
          algoliaAppId: csConf.algoliaApplicationID,
          algoliaApiKey: csConf.algoliaSearchKey,
          searchIndexNames: this.searchIndexNames,
          searchOptions
        }),
        facetParser: new FacetParser(),
        fragrances: [],
        selectedFilters: {},
        facetGroups: []
      };
    },
    computed: {
      resultsCountText() {
        const count = this.fragrances.length;
        if (count === 1) {
          return '1 fragrance';
        }
        return `${count} fragrances`;
      },
      searchIndices() {
        return Object.keys(this.searchClient.searchIndices);
      },
      slidingMenuCssClasses() {
        return this.mobileFacetMenuOpen ? 'sliding-menu visible' : 'sliding-menu';
      },
      anyResults() {
        return this.fragrances.length > 0;
      }
    },
    beforeRouteUpdate(to, from, next) {
      this.search();
      next();
    },
    created() {
      const parameters = this.$route.query;

      if (parameters.order) {
        this.searchClient.searchIndex = parameters.order;
        delete parameters.order;
      }

      if (Object.keys(parameters).length === 0) {
        this.selectedFilters = {};
      } else {
        this.selectedFilters = parameters;
      }
      this.search();
    },
    methods: {
      toggleMobileFacetMenu() {
        this.mobileFacetMenuOpen = !this.mobileFacetMenuOpen;
        const htmlElement = document.getElementsByTagName('html')[0];
        if (this.mobileFacetMenuOpen) {
          htmlElement.classList.add(this.screenLockClass);
        } else {
          htmlElement.classList.remove(this.screenLockClass);
        }
      },
      changeSearchIndex(event) {
        this.searchClient.searchIndex = event.target.value;
        this.updateRoutes();
      },
      clearAll() {
        this.selectedFilters = {};
        this.updateRoutes();
      },
      toggleFilter(event) {
        if (this.selectedFilters[event.displayName]) {
          const replacement = {
            ...this.selectedFilters
          };
          delete replacement[event.displayName];
          this.selectedFilters = replacement;
        } else {
          this.selectedFilters = {
            [event.displayName]: event.filterValue,
            ...this.selectedFilters
          };
        }
        this.updateRoutes();
      },
      updateRoutes() {
        this.$router.push({
          query: {
            order: this.searchClient.currentIndexName,
            ...this.selectedFilters
          }
        })
      },
      search() {
        this.searchClient.search({
          filters: Object.values(this.selectedFilters).join(' AND ')
        }).then((content) => {
          this.fragrances = content.hits;
          this.facetGroups = this.facetParser.parse(content.facets);
        }, (error) => {
          console.log(error);
        });
      }
    }
  };
</script>
